import { RelationshipProgressStatus, RelationshipStatus } from '~/models/relationship';
import { ProposalReportEntryStatus } from './types';
export const statusLabelMap = {
    [ProposalReportEntryStatus.All]: 'All',
    [ProposalReportEntryStatus.NotReviewed]: 'Not reviewed',
    [ProposalReportEntryStatus.Reviewed]: 'Reviewed',
    [ProposalReportEntryStatus.Signed]: 'Signed',
    [ProposalReportEntryStatus.Expired]: 'Expired',
    [ProposalReportEntryStatus.Withdrawn]: 'Withdrawn',
    [ProposalReportEntryStatus.Terminated]: 'Terminated'
};
export const calculateStatus = (summary)=>{
    if (summary.status === RelationshipStatus.Expired) return ProposalReportEntryStatus.Expired;
    if (summary.status === RelationshipStatus.Approved) return ProposalReportEntryStatus.Signed;
    if (summary.status === RelationshipStatus.Canceled) return ProposalReportEntryStatus.Withdrawn;
    if (summary.status === RelationshipStatus.Terminated) return ProposalReportEntryStatus.Terminated;
    if (summary.progressStatus === RelationshipProgressStatus.Sent && summary.status === RelationshipStatus.Pending) return ProposalReportEntryStatus.NotReviewed;
    if (summary.progressStatus === RelationshipProgressStatus.Reviewed && summary.status === RelationshipStatus.Pending) return ProposalReportEntryStatus.Reviewed;
    return ProposalReportEntryStatus.NotReviewed;
};
